import React from 'react';

export const isSingleDigitNumber = (value: string): boolean => {
	return value.length === 1;
};

export const tabInputDebounceFunction = (lastInputRef: React.MutableRefObject<any>, conversionHandler: (category: any, unit: string, value: string, skipAnalyticCall?: boolean) => void): void => {
	if (lastInputRef.current) {
		const { category, unit, value } = lastInputRef.current;

		const isSingleInteger = isSingleDigitNumber(value);
		const endsWithDot = value.lastIndexOf('.') === value.length - 1;

		if (endsWithDot || isSingleInteger) {
			// don't call API immediately if the last character is a dot or if the value is a single integer
			if (isSingleInteger) {
				// check for single integer, and reset the field after 1.5 seconds
				setTimeout(() => {
					const currentValue = Number.parseFloat(lastInputRef.current?.value ?? '').toString();
					// check for that the value is still single integer before submitting
					if ( isSingleDigitNumber(currentValue)) {
						conversionHandler(category, unit, currentValue);
					}
				}, 1200);
			}
			return;
		}

		conversionHandler(category, unit, value, false);
	}
};
